import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from '../../api/instance';
import { User } from './users.types';

const usersApiPath = '/users';

export const getUsers = async (): Promise<AxiosResponse<User[] & ApiError>> => {
  console.trace();
  return instance.get<User[]>(usersApiPath).catch(e => e.response as AxiosError<ApiError> as never);
};

export const createUser = async (data: Partial<User>): Promise<AxiosResponse<User & ApiError>> => {
  return instance.post<User>(usersApiPath, data).catch(e => e.response as AxiosError<ApiError> as never);
};

const userApiPath = (id: number) => `/users/${id}`;

export const getUser = async ({ userId }: { userId: number }): Promise<AxiosResponse<User & ApiError>> => {
  return instance.get<User>(userApiPath(userId)).catch(e => e.response as AxiosError<ApiError> as never);
};

export const updateUser = async ({
  userId,
  data,
}: {
  userId: number;
  data: Partial<User>;
}): Promise<AxiosResponse<User & ApiError>> => {
  return instance.post<User>(userApiPath(userId), data).catch(e => e.response as AxiosError<ApiError> as never);
};

export const deleteUser = async ({ userId }: { userId: number }): Promise<AxiosResponse<User & ApiError>> => {
  return instance.delete<User>(userApiPath(userId)).catch(e => e.response as AxiosError<ApiError> as never);
};
